import React, { Component } from 'react'
//import IconStart from '@learningblocks/protocol-constants/lib/Icons/start-solid'
import ToastIcon from './img/toast-icon.svg'
//import FocusLock, { AutoFocusInside } from 'react-focus-lock'
import colors from '@learningblocks/protocol-constants/lib/Styles/_colors.scss'

import './Toast.scss'

const CloseButton = ({ closeToast }) => (
  <i tabIndex="0"
    style={{position: 'absolute', top: '4px', right: '4px', fontStyle: 'normal'}}
    className="material-icons"
    aria-label="close alert"
    onKeyPress={closeToast}
    onClick={closeToast}
  >✖</i>
);

class Toast extends Component {

    genIconContainer = () => {
        //let icon = <IconStart />
        let color = colors.charcoal1

        switch (this.props.type) {
            case "WARNING":
                color = colors.red2
                break;

            case "HINT":
                color = colors.yellow1
                break;

            default:
                break;
        }

        return (
            <div className="toast-img-container"
                style={{backgroundColor:color}}>
                <img className="toast-icon" src={ToastIcon} alt="" />
            </div>
        )
    }

    componentDidMount(){
      this.toast.focus();
    }

    render() {
        return (
          //<FocusLock disabled={false}>
            <div className="toast-container">
                <CloseButton closeToast={this.props.closeToast}/>
                {this.genIconContainer()}
                <div className="toast-text-container" data-autofocus ref={(toast)=>{this.toast=toast;}} onClick={this.props.closeToast} tabIndex="0">
                    <p className="toast-text-heading">{this.props.title}</p>
                    <p className="toast-text-message">{this.props.msg}</p>
                </div>
            </div>
          //</FocusLock>
        );
    }
}

export default Toast;
